var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.$route.name != 'Login' && this.$route.name != 'Root')?_c('dashBoard-view'):_c('default-view'),_c('loader-overlay'),_c('notifier')],1)}
var staticRenderFns = []

export { render, staticRenderFns }